<template>
<b-dropdown right no-caret>
  <template slot="button-content">
    <img src="static/img/assets/edit.png">
  </template>
    <b-dropdown-item :to="{ name: 'FbRegist', params: { item: this.getFeed, id: this.getKey } }">{{$t('rtfbEditType')}}</b-dropdown-item>
    <b-dropdown-item @click="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
</b-dropdown>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FbDropDown',
  props: {
    item: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      removeTarget: {
        id: '',
        target: ''
      }
    }
  },
  computed: {
    getFeed: function () {
      return this.item
    },
    getKey: function () {
      return this.id
    }
  },
  methods: {
    ...mapActions({
      removeItem: 'REMOVE_ITEM'
    }),
    onClickDelete: function () {
      // let removeTarget
      const $t = this.$t
      this.removeTarget.id = this.getKey
      this.removeTarget.target = 'rtfbs'
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('doDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 5000
      }).then((result) => {
        if (result.value) {
          // okが押下されたら
          console.log('true')
          this.removeItem(this.removeTarget)
          this.$swal({
            title: $t('compDeleteStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        } else {
          // cancelが押下されたら
          console.log('false')
        }
      })
    }
  }
}
</script>
<style scoped>
.dropdown-item {
  color: #151b1e;
}
</style>



// WEBPACK FOOTER //
// src/components/Fb/FbDropDown.vue